import isArray from './isArray'

function each(obj, cb) {
    let i
    if (!obj) return obj
    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            if (cb.apply(obj[i], [obj[i], i]) === false)
                break;
        }
    }
    else {
        i = 0
        for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) {
                if (cb.apply(obj[key], [obj[key], key, i++]) === false)
                    break;
            }
        }
    }
    return obj
}

export default each